import React from "react";

export function HostedPolicies() {
  return (
    <div className="flex items-center justify-center min-h-screen bg-gray-100">
      <div className="max-w-3xl w-full p-6 bg-white rounded-lg shadow-md">

    <div className="flex justify-center items-center text-center"> 
        <img
          width="200"
          height="293"
          src="https://javasrvbucket.s3.amazonaws.com/2dded436-5154-4b77-bc79-f4741cb0d79f.png"
          alt="Policies"

        ></img>
</div>
        <h1 className="text-4xl font-bold text-gray-800 mb-8 text-center mt-4">
          Privacy Policy
        </h1>
        <div className="text-gray-700 space-y-4">
          <p>
            <strong>Privacy Policy!</strong>
          </p>
          <p>
            <strong>Giftr</strong> service is offered at no cost and is intended
            for use as-is. This Privacy Policy is designed to inform users
            regarding our policies with the collection, use, and disclosure of
            Personal Information for those who choose to use our service.
          </p>

          <p>
            By using the Giftr app, you agree to the collection and use of
            information in accordance with this policy. We are committed to
            protecting your privacy and ensuring your data is handled securely.
          </p>

          <h2>Information Collection and Use</h2>
          <p>
            To provide a better experience, we may require you to provide
            certain personally identifiable information, including but not
            limited to:
          </p>
          <ul>
            <li>Full Name</li>
            <li>Email Address</li>
            <li>Phone Number</li>
            <li>Date of Birth (optional, for occasion reminders)</li>
            <li>State and Country</li>
            <li>Recipient Information (for sending gifts/vouchers)</li>
          </ul>
          <p>
            The information collected is used to facilitate voucher sending,
            occasion reminders, customization features, and to improve our
            services.
          </p>

          <h2>Voucher Customization and Media Access</h2>
          <p>
            If you choose to customize vouchers, the app may request access to
            your device’s media storage or camera to upload images or messages.
            These are used only for generating personalized vouchers and are not
            shared or stored beyond what is necessary for processing.
          </p>

          <h2>Log Data</h2>
          <p>
            In case of an error in the app, we collect data and information (via
            third-party services) on your device called Log Data. This may
            include:
          </p>
          <ul>
            <li>Device IP address</li>
            <li>Device name</li>
            <li>Operating system version</li>
            <li>App configuration</li>
            <li>Timestamp of usage</li>
          </ul>
          <p>
            This data helps us diagnose and fix issues to improve the app’s
            performance.
          </p>

          <h2>Cookies</h2>
          <p>
            While Giftr does not use cookies explicitly, some third-party
            libraries or services we use may do so to collect information and
            enhance their services.
          </p>

          <h2>Third-Party Services</h2>
          <p>
            We may employ third-party companies and individuals for the
            following reasons:
          </p>
          <ul>
            <li>To facilitate our service</li>
            <li>To provide the service on our behalf</li>
            <li>To perform service-related tasks</li>
            <li>To help us analyze how our service is used</li>
          </ul>
          <p>
            These third parties have access to your personal information only to
            perform tasks on our behalf and are obligated not to disclose or use
            it for any other purpose.
          </p>

          <h2>Security</h2>
          <p>
            We value your trust in providing us with your personal information,
            thus we strive to use commercially acceptable means of protecting
            it. However, please remember that no method of transmission over the
            internet or method of electronic storage is 100% secure.
          </p>

          <h2>Links to Other Sites</h2>
          <p>
            Giftr may contain links to external websites. If you click on a
            third-party link, you will be directed to that site. We strongly
            advise you to review the Privacy Policy of these websites, as we
            have no control over their practices.
          </p>

          <h2>Children’s Privacy</h2>
          <p>
            Giftr is not intended for use by anyone under the age of 13. We do
            not knowingly collect personally identifiable information from
            children under 13. If we discover such data has been collected, we
            will immediately delete it.
          </p>

          <h2>Facial Data and Image Processing</h2>
          <p>
            If our service includes a feature allowing users to apply facial or
            visual effects to vouchers, any facial image data processed is used
            solely for that purpose. No biometric recognition or profiling is
            performed. Images are processed locally or temporarily stored and
            deleted after voucher generation is complete.
          </p>

          <h2>Data Retention</h2>
          <p>
            User data, including images or media used for voucher customization,
            is retained for the duration necessary to complete the service.
            Customization assets are automatically deleted from our servers
            within 20 days of submission unless required for longer for user
            access or legal compliance.
          </p>

          <h2>Your Rights</h2>
          <p>
            You have the right to access, modify, or delete your personal data.
            You may contact us at any time at{" "}
            <strong>[Insert Support Email]</strong> to make such requests.
          </p>

          <h2>Changes to This Privacy Policy</h2>
          <p>
            We may update our Privacy Policy from time to time. Users are
            encouraged to review this page periodically. Changes will be posted
            with an updated "Effective Date" at the top of this page.
          </p>

          <h2>Contact Us</h2>
          <p>
            If you have any questions or suggestions about our Privacy Policy,
            do not hesitate to contact us at:
          </p>
          <ul>
            <li>
              <strong>Email:</strong> support@giftr.com.sg
            </li>
          </ul>
        </div>
      </div>
    </div>
  );
}
